import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78ef2df0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ef2df0')) {
      api.createRecord('78ef2df0', component.options)
    } else {
      api.reload('78ef2df0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78ef2df0&", function () {
      api.rerender('78ef2df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/clearance/index.vue"
export default component.exports